import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P72-E1',
    audio: '',
    video: '',
    component: UI,
    textAlign: 'center',
    titleImage: '',
    exerciseKey: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page72/2.jpg' },
      ]
    ]
  },
  2: {
    // Exercise num
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P72-E2',
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page72/E2/Key/answerKey.png",
    inputSize: 190,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: '#3F3478', num: '2', title: "Read the email again. Write." }],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='line-height:50px'>
              <img src='img/FriendsPlus/Page72/E2/1.jpg' />
              <div><b> 1 &nbsp</b> What does Kim like? Kim likes Nga’s   <u style='color: gray;'> <i> ao dai. </i></u></div>
              <div><b> 2 &nbsp</b> How old is the baby? The baby is # months old.</div>
              <div><b> 3 &nbsp</b> What’s the baby’s name? The baby’s name is # </div>
              <div><b> 4 &nbsp</b> What color are the baby’s eyes? The baby’s eyes # </div>
              <div><b> 5 &nbsp</b> How does Kim’s family feel? Kim’s family # </div>
          </div>
        `,
        answer: ["nine", "Minh.", "are black.", "is very happy."],
      },
    ],
  },





}
export default json;